import React from "react";
import { Link, useLocation } from "react-router-dom";

import { Anchor, Breadcrumbs as MantineBreadcrumbs, Text } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";

import { t } from "i18next";

const labelFor = (segment: string) => {
  const lower = segment.toLowerCase();
  const lookup = t(`menu.${lower}`, { defaultValue: "" });
  if (lookup) return lookup;
  return segment.charAt(0).toUpperCase() + segment.slice(1);
};

const BraouBreadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter(Boolean);

  if (pathSnippets.length === 0) return null;

  const items: React.ReactNode[] = [
    <Anchor key="home" component={Link} to="/" size="sm" c="sea.6" fw={500}>
      {t("common.home")}
    </Anchor>,
  ];

  pathSnippets.forEach((segment, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    const isLast = index === pathSnippets.length - 1;
    items.push(
      isLast ? (
        <Text key={url} size="sm" c="dimmed">
          {labelFor(segment)}
        </Text>
      ) : (
        <Anchor
          key={url}
          component={Link}
          to={url}
          size="sm"
          c="sea.6"
          fw={500}
        >
          {labelFor(segment)}
        </Anchor>
      ),
    );
  });

  return (
    <MantineBreadcrumbs
      separator={<IconChevronRight size={14} stroke={1.6} />}
      separatorMargin={6}
    >
      {items}
    </MantineBreadcrumbs>
  );
};

export default BraouBreadcrumbs;
